// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"e1193586","356":"d76d1cef","898":"3a978c1a","964":"f4f032f8"}[chunkId] + ".chunk.js";
};